import * as yup from "yup";
export const validationSchemaVocacional = yup.object({
  nombreCompleto: yup.string().required("Nombre completo es requerido"),
  numeroIdentidad: yup
    .string()
    .transform(value => {
      // Acomodar el número y agregar los guiones
      if (value && value.length === 13 && /^\d{13}$/.test(value)) {
        return `${value.slice(0, 4)}-${value.slice(4, 8)}-${value.slice(8)}`;
      }
      return value; // Retornar el valor sin cambios si no tiene 13 dígitos
    })
    .matches(/^(?:\d{4}-){2}\d{5}$/, "La identidad puede tener el formato XXXX-XXXX-XXXXX ó XXXXXXXXXXXXX"),   
  sexo: yup.string().required("Sexo es requerido"),
  telefono: yup.string().required("Teléfono es requerido")
  .matches(/^[23789]\d{7}$/, 'El número debe comenzar con 2, 3, 7, 8 o 9 y tener 8 dígitos.'),
  correoElectronico: yup
    .string()
    .email("Ingrese un correo válido")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Ingrese un correo con un dominio válido (.com, .org, etc.)"
    )
    .required("Correo electrónico es requerido"),
    colegio: yup
    .string()    
    .required("Colegio es requerido"),
    nombreOtros: yup
  .string()
  .test(
    "nombreOtros-required", // Nombre del test (puedes llamarlo como quieras)
    "Debe ingresar el nombre del colegio.", // Mensaje de error
    function (value) {
      const { colegio } = this.parent; // Accede al valor de 'colegio'
      // Valida si 'colegio' es 'otros' y si el campo está vacío
      if (colegio === "otros") {
        return !!value && value.trim() !== ""; // Es requerido si el colegio es "otros"
      }
      return true; // No valida si 'colegio' no es "otros"
    }
  ),
  departamentoColegio: yup
    .string()
    .required("Departamento de colegio es requerido"),
  departamentoResidencia: yup
    .string()
    .required("Departamento de residencia es requerido"),
  campusInteres: yup.string().required("Campus de interés es requerido"),
  carreraInteres: yup.string().required("Carrera de interés es requerida"),
 
});
